module.exports = __webpack_public_path__ + "static/media/paper-dark.326400cf.png";